"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        description: 'Driver is not yet assigned to a tour',
        id: 1,
        name: 'DRIVER_UNASSIGNED',
    },
    {
        description: 'Driver is assigned to a tour',
        id: 2,
        name: 'DRIVER_ASSIGNED',
    },
    {
        description: 'Driver has started the tour',
        id: 3,
        name: 'DRIVER_STARTED',
    },
    {
        description: 'Driver is currently driving',
        id: 4,
        name: 'DRIVER_DRIVING',
    },
    {
        description: 'Driver is currently stationary',
        id: 5,
        name: 'DRIVER_STATIONARY',
    },
    {
        description: 'Driver is done with the tour',
        id: 6,
        name: 'DRIVER_DONE',
    },
    {
        description: 'Driver is not active',
        id: 7,
        name: 'DRIVER_INACTIVE',
    },
    {
        description: 'Driver is active',
        id: 8,
        name: 'DRIVER_ACTIVE',
    },
];
